import { useMutation } from '@tanstack/react-query';
import type {
  ProvidedJobPostsPostRequest,
  ProvidedJobPostsResponse,
} from '../types/ProvidedJobPost';

export default function usePutProvidedJobPost(id: number) {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({
      title,
      working_location,
      job_position_name,
      employment_type,
      job_content_json,
      min_salary,
      max_salary,
      company_id,
      status,
    }: ProvidedJobPostsPostRequest) => {
      const response = await fetch(`/agent/api/provided_job_posts/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          title,
          working_location,
          job_position_name,
          employment_type,
          job_content_json,
          min_salary,
          max_salary,
          company_id,
          status,
        }),
      });
      const data: ProvidedJobPostsResponse = await response.json();
      return data;
    },
  });
}
